/**
 * The locale the SEO copy was written for. Frank Agency delivered Swedish only.
 *
 * Kept free of imports so client code (the menu) can read it without dragging
 * serverSideTranslations, and its `fs` dependency, into the browser bundle.
 */
export const SEO_LOCALE = 'sv'
